function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Clean-design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mobile-_-01.01.-Brauk\\u0161anas-nodarb\\u012Bbas---Kopsavilkums",
  transform: "translate(-195.000000, -480.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "BLOCK",
  transform: "translate(10.000000, 409.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Table",
  transform: "translate(1.000000, 53.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Columns",
  transform: "translate(19.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(165.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "viewbox",
  points: "0 0 24 0 24 24 0 24"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#079DC1",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 12,
  cy: 12,
  r: 10
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path-2",
  stroke: "#079DC1",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "12 6 12 12 16 12"
}))))))));

function SvgIcClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5F94AC8A-555D-429B-B49D-FD2787A45ED5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClock);
export default __webpack_public_path__ + "static/media/ic-clock.62e0b83f.svg";
export { ForwardRef as ReactComponent };